import { includes } from 'lodash';

import { IMAGE_CONFIG_VALUE } from '../utils/constants';

const cloudinaryConfigParams = {
  width: 'w_',
  height: 'h_',
  crop: 'c_',
  fetchFormat: 'f_',
  gravity: 'g_',
  aspectRatio: 'ar_',
  quality: 'q_',
};

const consecutiveSlashes = /(\/)\1+/g; // matches: [//], [///], [/(n)]
const trailingSlash = /\/$/; // matches: string[/]

/**
 * Builds the image source for the given params
 * @param {string} config - cloudinary values for image optimization
 * @param {string} src - image source
 * @param {bool} isClientImage - uploaded by client an requires special treatment
 * @returns {string} cloudinary path for local, dev, qa or prod environments
 */
export const buildImagePath = (config, src, isClientImage) => {
  /**
   * Cloudinary sources are build with the following structure:
   * {domain}/{name}/image/upload/{congif}/{folder}/{src} (dynamically updloaded)
   * {src[0]/{config}/{src[1]} (manually uploaded images, always points to prod)
   */
  if (isClientImage) {
    return src.split(`${IMAGE_CONFIG_VALUE}`).join(config);
  }

  /*
   * Domain:
   *  - local: none
   *  - dev: https://res.cloudinary.com/
   *  - qa: https://res.cloudinary.com/
   *  - prod: https://assets.iwgplc.com/
   *
   * Name:
   *  - local: none
   *  - dev: iwgdev
   *  - qa: iwgqa
   *  - prod: none
   *
   * Config: cloudinary attributes to set image size and quality
   *
   * Folder:
   *  - local: none
   *  - dev: iwg
   *  - qa: iwg
   *  - pro: Sitecore/CD
   *
   * Src: image source in sitecore
   */
  const cloudDomain = process.env.REACT_APP_CLOUDINARY_DOMAIN;
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUDNAME;
  const cloudFolder = process.env.REACT_APP_CLOUDINARY_FOLDER;
  const isCloudinaryEnabled = process.env.REACT_APP_CLOUDINARY_ENABLED || false;

  // Fallback to Sitecore if domain is not defined or enable flag is true
  if (!isCloudinaryEnabled || !cloudDomain) {
    return `/${src}`.replace(consecutiveSlashes, '$1');
  }

  const path = `/${
    cloudName || ''
  }/image/upload/${config}/${cloudFolder}/${src}`;
  const pathSanitized = path.replace(consecutiveSlashes, '$1');
  const domainSanitized = cloudDomain.replace(trailingSlash, '');

  return `${domainSanitized}${pathSanitized}`;
};

export const parseUrlConfigParams = breakpoint => {
  let entries = Object.entries(breakpoint);
  entries = entries.filter(entry => cloudinaryConfigParams[entry[0]]);
  let config = entries
    .map(([key, value]) => cloudinaryConfigParams[key] + value)
    .join(',');
  let retinaConfig = entries
    .map(([key, value]) =>
      includes(['width', 'height'], key)
        ? `${cloudinaryConfigParams[key]}${value * 2}`
        : `${cloudinaryConfigParams[key]}${value}`,
    )
    .join(',');

  return { config, retinaConfig };
};
